module.exports = "https://www.svtstatic.se/play/play7/_next/static/images/nyhetsbrev-f560c8ed3341a6e3b32f96d6fd5c6249.jpg";